import React from 'react'
import Register from '../pages/auth/register'
import Login from '../pages/auth/login'
import ForgotPassword from '../pages/auth/forgot-password'
import Dashboard from '../pages/dashboard'
import ResetPassword from '../pages/auth/reset-password'
import PropertyPage from '../pages/properties'
import Schedules from '../pages/schedule'
import AddEditProperty from '../pages/properties/addEditProperty'
import Profile from '../pages/auth/profile'
import CleaningDetails from '../component/Schedule/cleaningDetails'
import Reviews from '../pages/reviews'
import Billings from '../pages/billings'
import Notifications from '../pages/notifications'
import ChatApp from '../pages/chat'

export const unAuthRoutes = [
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    path: '/reset-password',
    // path: `${'/reset-password/:token'}`,
    element: <ResetPassword />
  }
]

export const authRoutes = [
  {
    path: '/',
    element: <Dashboard />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/schedules',
    element: <Schedules />
  },
  {
    path: '/properties',
    element: <PropertyPage />
  },
  {
    path: '/add-property',
    element: <AddEditProperty />
  },
  {
    path: `${'/edit-property'}/:property_id`,
    element: <AddEditProperty />
  },
  {
    path: `${'/cleaning-details/:schedule_id'}`,
    element: <CleaningDetails />
  },
  {
    path: `/reviews`,
    element: <Reviews />
  },
  {
    path: `/notifications`,
    element: <Notifications />
  },
  {
    path: `/billings`,
    element: <Billings />
  },
  {
    path:`/chat/:room_id`,
    element:<ChatApp />
  }
]
